import { Route, Routes } from 'react-router-dom'
import { ChecklistSubmit, Home, LoginPage, Profile, ResetPassword, PrivacyPolicy, StockReport, DamageEntry } from './screens';
import ProtectedRoutes from './ProtectedRoutes';
import PublicRoute from './PublicRoute';

const AppRoutes = () => {
    return (
        <Routes>
            {/* Only for logged-out users */}
            <Route element={<PublicRoute />}>
                <Route path='/' element={<LoginPage />} />
            </Route>

            <Route path='/reset-password' element={<ResetPassword />} />

            <Route element={<ProtectedRoutes />}>
                <Route path='/home' element={<Home />} />
                <Route path='/checklist' element={<ChecklistSubmit />} />
                <Route path='/profile' element={<Profile />} />
                <Route path='/stock-report' element={<StockReport />} />
                <Route path='/damage-entry' element={<DamageEntry />} />
            </Route>

            <Route path='/privacy-policy' element={<PrivacyPolicy />} />
        </Routes>
    )
}

export default AppRoutes;